import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html',
  styleUrls: ['./edit-company.component.scss']
})
export class EditCompanyComponent implements OnInit {
  public editCompanyForm;

  constructor(private dialogRef: MdDialogRef<EditCompanyComponent>,
              private formBuilder: FormBuilder,
              @Inject(MD_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.editCompanyForm = this.formBuilder.group({
      name: [this.data.company.name, Validators.required],
      maxAllowedUsers: [this.data.company.maxAllowedUsers, [Validators.required, Validators.min(0)]]
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick(customerData) {
    this.dialogRef.close(customerData);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/shared/edit-company/edit-company.component.ts